const InputMask = () => {
  $('[rel="cpf"]').mask('000.000.000-00', {
    placeholder: '___.___.___-__'
  });
  $('[rel="phone"]').mask('(00) 00000-0000', {
    placeholder: '(__) _____-____'
  });
  $('[rel="cep"]').mask('00000-000', {
    placeholder: '_____-___'
  });
  $('[rel="date"]').mask('00/00/0000', {
    placeholder: 'dd/mm/aaaa'
  });
  $('[type="number"]').mask('000000');
};

export default InputMask;



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/app/assets/javascripts/packs/auth/inputMask.js